module.exports = __webpack_public_path__ + "media/images/photos/headlight-damage-f4ad8c63089d1c396ba143758bb4ddec.jpg";